import React from 'react';
import './Modal.scss';

const Modal = ({ children }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'></div>
            <div className='col-md-6'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
